import { fetchContentAssistanceSettings, fetchBrandVoiceByBusinessUnitId, fetchBrandVoiceByContentId } from 'ContentEditorUI/api/ContentAssistantApi';
import { GET_CONTENT_ASSISTANT_SETTINGS, GET_BRAND_VOICE_SETTINGS, GET_BRAND_VOICE_SETTINGS_NOT_FOUND } from 'ContentEditorUI/redux/actions/actionTypes';
import { getHasAccessToBrandVoice } from 'ContentEditorUI/redux/selectors/contentAssistantSelectors';
import { getHasBusinessUnitsAccess } from '../selectors/authSelectors';
import rpcClient from 'ContentEditorUI/api/RpcClient';
import { getAccessControlsRpc } from 'ContentEditorUI/__generated__/chirp/com/hubspot/ai/access/controls/rpc/AiAccessControlsChirpService';
// @ts-expect-error not migrated to TS yet
import { getRoutingContentId } from '../selectors/routingSelectors';
import { DEFAULT_ACCOUNT_BUSINESS_UNIT_ID } from 'ui-business-units-lib/constants/BusinessUnit';
const fetchBrandVoiceSettings = async ({
  state,
  businessUnitId
}) => {
  const hasBusinessUnitsAccess = getHasBusinessUnitsAccess(state);
  const routingContentId = getRoutingContentId();
  if (hasBusinessUnitsAccess) {
    if (Number.isInteger(businessUnitId)) {
      return await fetchBrandVoiceByBusinessUnitId({
        businessUnitId
      });
    }
    if (Number.isInteger(Number(routingContentId))) {
      return await fetchBrandVoiceByContentId({
        contentId: routingContentId
      });
    }
  }
  return await fetchBrandVoiceByBusinessUnitId({
    businessUnitId: DEFAULT_ACCOUNT_BUSINESS_UNIT_ID
  });
};
export const getContentAssistantSettings = requestConfig => async (dispatch, getState) => {
  let contentAssistanceSettings;
  let brandVoiceSettings;
  let unifiedAiSettings;
  let generativeAiEnabled = false;
  let crmPropertiesEnabled = false;
  try {
    var _requestConfig$brandV;
    const state = getState();
    const contentAssistanceSettingsPromise = fetchContentAssistanceSettings();
    // TODO: Just use the unified AI settings call once Content Assistant Settings
    // is deprecated
    const unifiedAiSettingsPromise = rpcClient.call(getAccessControlsRpc, {});
    [contentAssistanceSettings, unifiedAiSettings] = await Promise.all([contentAssistanceSettingsPromise, unifiedAiSettingsPromise]);
    if (unifiedAiSettings) {
      contentAssistanceSettings.contentAssistanceEnabled = unifiedAiSettings.copilotEnabled;
      generativeAiEnabled = unifiedAiSettings.generativeAiEnabled;
      crmPropertiesEnabled = unifiedAiSettings.crmPropertiesEnabled;
    }
    if (!(requestConfig !== null && requestConfig !== void 0 && (_requestConfig$brandV = requestConfig.brandVoice) !== null && _requestConfig$brandV !== void 0 && _requestConfig$brandV.skip) && getHasAccessToBrandVoice(state)) {
      brandVoiceSettings = await fetchBrandVoiceSettings({
        state
      });
    }
    dispatch({
      type: GET_CONTENT_ASSISTANT_SETTINGS,
      payload: Object.assign({}, contentAssistanceSettings, {
        brandVoiceSettings,
        generativeAiEnabled,
        crmPropertiesEnabled
      })
    });
  } catch (error) {
    var _contentAssistanceSet;
    // Fallback to default settings when request fails
    (_contentAssistanceSet = contentAssistanceSettings) !== null && _contentAssistanceSet !== void 0 ? _contentAssistanceSet : contentAssistanceSettings = {
      contentAssistanceEnabled: false,
      blogBrandVoiceEnabled: false
    };
    dispatch({
      type: GET_CONTENT_ASSISTANT_SETTINGS,
      payload: Object.assign({}, contentAssistanceSettings, {
        generativeAiEnabled,
        crmPropertiesEnabled
      })
    });
  }
};
export const getBrandVoiceSettings = ({
  businessUnitId
}) => async (dispatch, getState) => {
  const state = getState();
  const hasBusinessUnitsAccess = getHasBusinessUnitsAccess(state);
  try {
    const brandVoiceSettings = await fetchBrandVoiceSettings({
      state,
      businessUnitId
    });
    dispatch({
      type: GET_BRAND_VOICE_SETTINGS,
      payload: {
        brandVoiceSettings
      }
    });
  } catch (error) {
    dispatch({
      type: GET_BRAND_VOICE_SETTINGS_NOT_FOUND,
      payload: {
        businessUnitId: hasBusinessUnitsAccess ? businessUnitId : DEFAULT_ACCOUNT_BUSINESS_UNIT_ID
      }
    });
  }
};